import { render, staticRenderFns } from "./xcxbanner.vue?vue&type=template&id=32885f81&scoped=true&"
import script from "./xcxbanner.vue?vue&type=script&lang=js&"
export * from "./xcxbanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32885f81",
  null
  
)

export default component.exports